import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import AppLink from 'components/AppLink';
import Avatar from 'components/Avatar';
import Social from 'components/Social';

import RFPProfileLink from 'components/RFPProfileLink';
import styles from './styles.styl';
import { Typography } from 'ui/Typography';

const AuthorBlock = React.forwardRef(function(
  { className = '', name, avatar, social = [], position = '', city, site, url, domain },
  forwardRef,
) {
  const hasOneChild =
    (Boolean(social.length) && !position && !city && !site) ||
    (!social.length && position && !city && !site) ||
    (Boolean(social.length) && !position && city && !site) ||
    (Boolean(social.length) && !position && !city && Boolean(site));

  const hasRFPProfile = Boolean(domain);

  return (
    <div ref={forwardRef} className={cn(styles.AuthorBlock, className)}>
      <div className={styles.AuthorBlock__author}>
        <Avatar
          className={styles.AuthorBlock__avatar}
          size={120}
          image={avatar}
          border
          borderColor="#eceee3"
        />
        <div className={styles.AuthorBlock__heading}>
          <Typography element="h1" className={styles.AuthorBlock__name} level={1}>
            {name}
          </Typography>
          {hasRFPProfile && <RFPProfileLink domain={domain} />}
        </div>
      </div>
      <div
        className={cn(styles.AuthorBlock__info, {
          [styles.AuthorBlock__info_center]: hasOneChild,
        })}
      >
        {Boolean(social.length) && (
          <Social className={styles.AuthorBlock__socials} socials={social} />
        )}
        {position && <p className={styles.AuthorBlock__text}>{position}</p>}
        {city && <p className={styles.AuthorBlock__text}>{city}</p>}
        {Boolean(site) && (
          <AppLink href={url} className={styles.AuthorBlock__link}>
            {site}
          </AppLink>
        )}
      </div>
    </div>
  );
});

AuthorBlock.displayName = 'AuthorBlock';

AuthorBlock.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  avatar: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
  social: PropTypes.array,
  position: PropTypes.string,
  city: PropTypes.string,
  site: PropTypes.string,
  url: PropTypes.string,
  domain: PropTypes.string,
};

export default AuthorBlock;
